import { Box, Center, Icon, Text, VStack } from '@chakra-ui/react';

export default function QuickAccessTile({ icon, label, count, onClick, colorScheme = 'purple' }) {
    const colorConfig = {
        primary: {
            iconBg: 'primary.100',
            iconColor: 'primary.600',
            hoverBg: 'primary.100',
        },
        green: {
            iconBg: 'green.100',
            iconColor: 'green.600',
            hoverBg: 'green.100',
        },
        pink: {
            iconBg: 'pink.100',
            iconColor: 'pink.600',
            hoverBg: 'pink.100',
        },
        orange: {
            iconBg: 'orange.100',
            iconColor: 'orange.600',
            hoverBg: 'orange.100',
        },
    };

    const colors = colorConfig[colorScheme] || colorConfig.purple;

    return (
        <Box
            role='group'
            bg='white'
            borderRadius='2xl'
            p={{ base: 4, md: 6 }}
            border='1px'
            borderColor='gray.100'
            cursor='pointer'
            onClick={onClick}
            minH={{ base: '140px', md: '180px' }}
            _hover={{
                bg: colors.hoverBg,
                transform: 'translateY(-4px)',
            }}
            transition='all 0.3s'>
            <VStack spacing={{ base: 3, md: 4 }}>
                <Center
                    w={{ base: '60px', md: '80px' }}
                    h={{ base: '60px', md: '80px' }}
                    bg={colors.iconBg}
                    borderRadius='2xl'
                    color={colors.iconColor}
                    transition='all 0.25s ease-in-out'
                    border='2px'
                    borderColor='white'
                    _groupHover={{ bg: colors.iconColor, color: 'white', borderColor: colors.iconColor }}>
                    <Icon as={icon} fontSize={{ base: 30, md: 40 }} />
                </Center>

                <VStack spacing={1}>
                    <Text fontSize={{ base: 'md', md: 'lg' }} fontWeight='semibold' color='gray.600' textAlign='center'>
                        {label}
                    </Text>
                    {count !== undefined && (
                        <Text fontSize={{ base: 'xs', md: 'sm' }} color='gray.500'>
                            {count} {count === 1 ? 'item' : 'items'}
                        </Text>
                    )}
                </VStack>
            </VStack>
        </Box>
    );
}
